import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

/**
 * Confirmation dialog for cancelling a subscription.
 * Use in admin subscription detail and other admin flows.
 */
export default function CancelSubscriptionDialog({
  open,
  onClose,
  onConfirm,
  loading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="cancel-subscription-dialog-title"
      aria-describedby="cancel-subscription-dialog-description"
    >
      <DialogTitle id="cancel-subscription-dialog-title">
        Cancel Subscription?
      </DialogTitle>
      <DialogContent>
        <Typography id="cancel-subscription-dialog-description">
          Are you sure you want to cancel this subscription? The status will be
          set to cancelled and the cancelled date will be recorded.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Keep Subscription
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <CancelIcon />
            )
          }
        >
          {loading ? "Cancelling..." : "Cancel Subscription"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
